export default __webpack_public_path__ + "static/media/step-2-inactivate.0e214231.svg";